const formGroupLabelIndicatorStyles = "@layer crnt-form-group-label-indicator {\n\t@layer base {\n\t\t.crnt-form-group-label-indicator {\n\t\t\tfont: var(--crnt-sem-typography-base-regular);\n\t\t\tcolor: var(--crnt-comp-label-color-fg-indicator);\n\t\t}\n\t}\n}\n";

export { formGroupLabelIndicatorStyles as default };
